import { useCallback, useEffect, useState } from "react";
import { useKey } from "react-use";
import { useAuth } from "react-oidc-context";
import { Outlet, useNavigate } from "react-router-dom";
import { User } from "oidc-client-ts";
import moment from "moment";
import { uri } from "@/global";

const logExpiry = (user: User) => {
  let { expires_in, expires_at } = user;
  if (!expires_at) return;
  if (!expires_in) {
    expires_in = moment(expires_at).diff(moment(), "seconds");
  }
  console.log(`[auth] expires ${moment(Date.now() + (expires_in * 1000)).fromNow()} at ${new Date(expires_at * 1000)}`);
};

export const AuthEvents = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [silentFailed, setSilentFailed] = useState(false);

  if (auth.user) logExpiry(auth.user);

  const refreshToken = useCallback(async () => {
    try {
      console.log("[OIDC] Dispatching silent signin.");
      const user = await auth.signinSilent();
      if (!user) throw new Error("No user returned.");
      console.log("[OIDC] Silent signin successful.", user.profile);
      setSilentFailed(false);
    } catch (err) {
      setSilentFailed(true);
      console.log("[OIDC] Silent signin failed.", err);
      // If silent refresh fails, redirect to login
      auth.signinRedirect();
    }
  }, [setSilentFailed, auth]);

  useEffect(() => {
    return auth.events.addAccessTokenExpiring(() => {
      console.log("[OIDC] Access token expiring.");
      refreshToken();
    });
  }, [auth.events, refreshToken]);

  useEffect(() => {
    if (auth.user && !auth.isLoading) {
      if (!silentFailed && auth.user.expired) {
        console.log('[OIDC] Token expired, trying silent refresh.');
        // expired, try silent refresh
        refreshToken();
      } else if (auth.isAuthenticated) {
        console.log('[OIDC] user is authenticated, ensuring we can try silent refresh.');
        // in case we failed then logged in, ensure silent fail is reset
        setSilentFailed(false);
      }
    }
  }, [setSilentFailed, auth, silentFailed, refreshToken]);

  // DEBUG press ctrl + alt + s to force a token refresh
  useKey((e) => e.ctrlKey && e.altKey && e.key === "s", (e) => refreshToken(), undefined, [refreshToken]);
  // useKey((e) => e.metaKey && e.altKey && e.key === "l", (e) => lock(), undefined, [lock]);

  // return <Outlet />;
  return null;
};